import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  enabled: false, // controlled ONLY by system_mode.is_notification
  notices: [],
};

const notificationSlice = createSlice({
  name: "base/notification",
  initialState,
  reducers: {
    enableNotification(state) {
      state.enabled = true;
    },
    disableNotification(state) {
      state.enabled = false;
      state.notices = [];
    },
    setNotices(state, action) {
      state.notices = Array.isArray(action.payload) ? action.payload : [];
    },
    clearNotifications(state) {
      state.enabled = false;
      state.notices = [];
    },
  },
});

export const {
  enableNotification,
  disableNotification,
  setNotices,
  clearNotifications,
} = notificationSlice.actions;

export default notificationSlice.reducer;
